const EVENT_NAME = {
  BUTTON_CLICK: 'Button Click',
  PAGE_VIEW: 'Page View',
  DROPDOWN: 'Dropdown',
  TEXT_INPUT: 'Text Input',
  DATE_PICKER: 'Date Picker'
};

export default EVENT_NAME;
